import React from "react";
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "../components/table";
import {cn} from "../lib/utils";
import {useTranslation} from "react-i18next";

const NutritionTable = ({metafields}: {metafields: RootObject["metafields"]}): React.ReactElement => {
  const {t} = useTranslation();

  const NUTRITION_TABLE_BODY = [
    {
      label: t("recipe_details.nutrition_table.energy_kcal"),
      value100g: `${metafields.nutrition.energykcal}`,
      valueMeal: `${metafields.nutritionpp.energykcal}`,
    },
    {
      label: t("recipe_details.nutrition_table.energy_kj"),
      value100g: `${metafields.nutrition.energykj}`,
      valueMeal: `${metafields.nutritionpp.energykj}`,
    },
    {
      label: t("recipe_details.nutrition_table.carbohydrates"),
      value100g: `${metafields.nutrition.carbohydrates} g`,
      valueMeal: `${metafields.nutritionpp.carbohydrates} g`,
    },
    {
      label: t("recipe_details.nutrition_table.sugars"),
      value100g: `${metafields.nutrition.carbohydratessugar} g`,
      valueMeal: `${metafields.nutritionpp.carbohydratessugar} g`,
    },
    {
      label: t("recipe_details.nutrition_table.fats"),
      value100g: `${metafields.nutrition.fat} g`,
      valueMeal: `${metafields.nutritionpp.fat} g`,
    },
    {
      label: t("recipe_details.nutrition_table.saturated"),
      value100g: `${metafields.nutrition.fatsaturates}`,
      valueMeal: `${metafields.nutritionpp.fatsaturates}`,
    },
    {
      label: t("recipe_details.nutrition_table.proteins"),
      value100g: `${metafields.nutrition.protein} g`,
      valueMeal: `${metafields.nutritionpp.protein} g`,
    },
    {
      label: t("recipe_details.nutrition_table.salt"),
      value100g: `${metafields.nutrition.salt} g`,
      valueMeal: `${metafields.nutritionpp.salt} g`,
    },
  ] as const;

  const shouldAddLeftPadding = (label: string) => label === t("recipe_details.nutrition_table.sugars") ||
    label === t("recipe_details.nutrition_table.saturated");

  return (
    <Table className="mb-4 md:my-5">
      <TableHeader>
        <TableRow>
          <TableHead></TableHead>
          <TableHead>100g</TableHead>
          <TableHead className="text-right">{t("recipe_details.nutrition_table.one_meal")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {NUTRITION_TABLE_BODY.map(({label, value100g, valueMeal}) => (
          <TableRow key={label}>
            <TableCell className={cn(shouldAddLeftPadding(label) && "!pl-8 md:!pl-12 max-sm:max-w-[57vw]")}>
              {label}
            </TableCell>
            <TableCell>{value100g}</TableCell>
            <TableCell className="text-right">{valueMeal}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export {NutritionTable};
